module.exports = __webpack_public_path__ + "static/media/grid_screen_6.3aa5561c.jpg";